const CATEGORIES_ACTION_TYPES = {
  // SET_CATEGORIES: "categories/SET_CATEGORIES",
  FETCH_CATEGORIES_START: "category/FETCH_CATEGORIES_START",
  FETCH_CATEGORIES_SUCCESS: "category/FETCH_CATEGORIES_SSUCCESS",
  FETCH_CATEGORIES_FAILED: "category/FETCH_CATEGORIES_FAILED",
};
export default CATEGORIES_ACTION_TYPES;
